<template>
    <div class="mPage">
        <div class="top">
            <img src="../img/m/m_logo.png" alt="" class="logo">
            <img src="../img/close_white.png" alt="" class="close" @click="closeNav">
        </div>
        <div class="content">
            <div class="languageCon">
                <div :class="{'currentLanguage': $i18n.locale=='cn'}" @click="changeLanguage('cn')">
                    中文
                </div>
                <div :class="{'currentLanguage': $i18n.locale=='en'}" @click="changeLanguage('en')">
                    English
                </div>
            </div>
            <div class="colorLine"></div>
            <ul class="navCon">
                <li @click="toDetail(0)">
                    <span>{{ $t("message.home") }}</span>
                </li>
                 <li @click="toDetail(1)">
                    <span>{{ $t("message.news") }}</span>
                </li>
                 <li @click="toDetail(2)">
                    <span>{{ $t("message.timeline") }}</span>
                </li>
                <li @click="toDetail(3)">
                    <span>{{ $t("message.guest") }}</span>
                </li>
                <li @click="toDetail(4)">
                    <span>{{ $t("message.awards") }}</span>
                </li>
                 <li @click="toDetail(5)">
                    <span>{{ $t("message.picture") }}</span>
                </li>
                 <li @click="toDetail(6)">
                    <span>{{ $t("message.resource") }}</span>
                </li>
                 <!-- <li @click="toDetail(6)">
                    <span>{{ $t("message.history") }}</span>
                </li> -->
            </ul>
            
            
        </div>
    </div>
</template>

<script>
import { setup } from "../../locales";
export default {
    name: 'm_navbar',
    data: function () {
        return {
        }
    },
    computed: {
  },
    methods: {
    // 切换语言
    changeLanguage(language) {
        setup(language)
    },
    setDefaultLanguage() {
      let currentLanguage = window.localStorage.getItem("localeLanguage")
    },
    closeNav () {
        this.$emit('close')
    },
    toDetail (index) {
        this.$emit('slideTo',index)
        this.$router.push({
            path: '/m_page/m_mainpage',
            query: {
                to: index
            }
        })
    }
  },
  mounted: function() {
    this.setDefaultLanguage()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mPage {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .top {
        height: 1.4rem;
        line-height: 1.4rem;
        position: relative;
        .logo {
            width: 1.27rem;
            margin: auto 0.34rem;
            vertical-align: middle;
        }
        .close {
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            right: 0.34rem;
            width: 0.51rem;
            vertical-align: middle;
        }
    }
    .content {
        margin-top: 30px;
        text-align: center;
        .languageCon {
            div {
                font-size: 0.41rem;
                color: #fff;
                display: inline-block;
                padding: 0 0.25rem 0.19rem;
                font-weight: bold;
            }
            .currentLanguage {
                border-bottom: 3px solid #f3bc65;
                color: #f3bc65;
            }
        }
        .colorLine {
            width: calc(100% - 0.34rem);
            float: right;
            height: 3px;
            background-image: linear-gradient(90deg, 
                #02baf2 0%, 
                #009dcd 100%), 
            linear-gradient(
                #5a87d3, 
                #5a87d3);
            background-blend-mode: normal, 
                normal;
                margin-top: -3px;

        }
        .navCon {
            margin-top: 0.72rem;
            text-align: center;
            li {
                font-size: 0.41rem;
                color: #fff;
                margin-bottom: 0.7rem;
            }
        }
        
        
    }
}
</style>
